

	import { Component, Prop, Watch } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';

	@Component({})
	export default class CompanyYearList extends BaseView {


		@Prop({ default: () => [] })
		public list: number[];

		public showClear: boolean = false;

		@Watch('$route', { immediate: true, deep: true })
		public checkForYearFilter() {
			this.showClear = false;
			if (this.$route.query.startYear || this.$route.query.endYear) {
				this.showClear = true;
			}
		}

	}

